import axios from 'axios';
// import moment from "moment";
// import {downloadFile} from "@/helpers/helpers";
import {getField, updateField} from 'vuex-map-fields';

const getDefaultState = () => {
    return {
        user: {
            id: null,
            manufacturers: [],
            sportBrands: [],
            name: null,
            lastname: null,
            job_title: null,
            email: null,
            password: null,
            password_confirmation: null,
            update_password: false,
            exist: false,
            credit: false,
            wallet: false,
        },
        config: {
            opts_genders: null,
            opts_tax_regime: null,
            opts_use_cdfi: null,
            countries: null,
            states: null,
        }
    }
}

export const state = getDefaultState();

export const getters = {
    all: (state) => state.all,
    roleName: (state) => {
        let name = ''
        if (state.user?.role !== null) {
            name = state.user?.role.name
        }
        return name;
    },
    getField
}

export const actions = {
    async me({commit}) {
        const response = await axios.get(`/fastmarket/account/contact`);
        commit('SET_USER', response.data.data);
    },
    async config({commit}) {
        const response = await axios.get(`/fastmarket/account/contact/config`);
        commit('SET_CONFIG', response.data);
    },
    async update({commit, state}) {
        let result = await axios.put(`/fastmarket/account/contact/update`, state.user);
        commit('SET_USER', result.data.contact);
    },
    async usecfdi({ commit }, clave) {
        const response = await axios.get(`/customerservice/orders/${clave}/usecfdi`);
        commit('SET_CUSTOMER_CFDI', response.data);
    },
}

export const mutations = {
    updateField,
    SET_USER(state, user) {
        state.user = {
            id: user.id,
            role: user.relationships.role,
            suppliers: user.relationships.suppliers,
            name: user.name,
            lastname: user.lastname,
            job_title: user.job_title,
            email: user.email,
            phone: user.phone,
            password: null,
            password_confirmation: null,
            update_password: false,
            credit_amount: user.relationships.b2bUser.credit,
            manufacturers: user.relationships.b2bUser.manufacturers_n,
            sportBrands: user.relationships.b2bUser.sports_brands,
            customer: user.relationships.b2bUser.customer,
            address: user.relationships.b2bUser.address,
            exist: true,
            fiscal:  user.relationships.b2bUser.rfc,
            rfc:  user.relationships.b2bUser.rfc,
            razon_social:  user.relationships.b2bUser.razon_social,
            cp_facturacion:  user.relationships.b2bUser.cp_facturacion,
            regimen_fiscal:  user.relationships.b2bUser.regimen_fiscal,
            uso_cfdi:  user.relationships.b2bUser.uso_cfdi,
            credit:  user.relationships.b2bUser.credit,
        };
    },
    SET_CONFIG(state, config) {
        state.config = config;
    },
    SET_CUSTOMER_CFDI: (state, use_cfdi) => {
        state.config.opts_use_cdfi = use_cfdi
        const results = use_cfdi.filter(obj => {
            return obj.clave === state.user.uso_cfdi;
        });
        if(results.length == 0) state.user.uso_cfdi = null;
    },
}